/* eslint-disable max-lines-per-function */
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetTechKeyword } from '@/infrastructure/api-functions/interface/get-tech-keyword.interface';
import type { AISearchRepository, AISearchRepositoryElementsParams, AISearchRepositoryElementsData } from '../../service/ai-search.repository.interface';
import { KeywordType } from '../../type/ai-search.enum';
import type VueI18n from 'vue-i18n';
import { Symbols } from '@/constants';
const MAX_FEATURE_COUNT = 5;

export const GetTechKeywordDTO = Symbol('GetTechKeywordDTO');

export interface GetTechKeywordDTO {
    fetch: AISearchRepository['getElements'];
}

@injectable()
export class GetTechKeywordDTOImpl implements GetTechKeywordDTO {
    constructor(
        @inject(Symbols.VueI18n)
        private _i18n: VueI18n,
        @inject(GetTechKeyword)
        private readonly _getTechKeywordApi: GetTechKeyword,
    ) { }

    async fetch(taskId: string, params: AISearchRepositoryElementsParams): Promise<AISearchRepositoryElementsData> {
        const data = await this._getTechKeywordApi.getTechKeyword({
            task_id: taskId,
            area: params.area,
            topics: params.topics.map(topic => {
                return {
                    topic_desc: topic.desc,
                    topic_name: topic.feature,
                };
            }),
        });

        const topic = {
            elements: (data.areas || []).map(area => {
                return {
                    element: area.element,
                    type: KeywordType.TOPIC,
                    keywords: area.keywords.map(keyword => {
                        return {
                            ...keyword,
                            value: (keyword.synonym || []).slice(0, 10),
                        };
                    }),
                };
            }),
        };

        const features = (data.features || []).map(feature => {
            return {
                ...feature,
                type: KeywordType.FEATURE,
            };
        });
        const effects = (data.effects || []).map(effect => {
            return {
                ...effect,
                type: KeywordType.EFFECT,
            };
        });
        const keywordList = [
            ...features,
            ...effects,
        ];
        const featureCount: { [key: string]: number } = {};

        const element = {
            elements: keywordList.map(item => {
                let isChecked = true;
                item.feature.forEach((feature: string) => {
                    if (!featureCount[feature]) {
                        featureCount[feature] = 0;
                    }
                    featureCount[feature] += 1;

                    if (featureCount[feature] > MAX_FEATURE_COUNT) {
                        isChecked = false;
                    }
                });


                return {
                    element: item.element,
                    feature: item.feature,
                    isChecked,
                    type: item.type,
                    keywords: item.keywords.map(keyword => {
                        return {
                            ...keyword,
                            value: (keyword.synonym || []).slice(0, 10),
                        };
                    }),
                };
            }),
        };
        return {
            topic,
            element,
        };
    }
}
